import { PropsWithChildren, useEffect, useState } from "react";
import { Avatar, Persona, makeStyles, shorthands, tokens } from "@fluentui/react-components";
import { IPrincipal } from "@interfaces/common.interfaces";
import Principal from "../common/principal/principal";
import Principals from "../common/principals/principals";

const layoutStyles = makeStyles({
    mainWrapper: {

    }
});

export default function PrincipalCell(props: { principal: IPrincipal }) {
    const styles = layoutStyles();

    return (
        <div className={styles.mainWrapper}>
            <Principal principal={props.principal} />
        </div>);
}